import { dialogActionTypes } from '../actions/dialogActions.js';

const initState = {
  open: false,
  onClose: null,
  title: '',
  message: '',
  buttons: [],
};

const handleOpenDialog = (state, { message, body, title, buttons, onClose }) => {
  return {
    ...state,
    ...{
      open: true,
      title,
      message,
      body,
      buttons,
      onClose,
    },
  };
};

const handleCloseDialog = (state) => {
  return { ...state, ...{ open: false } };
};

export default function reduce(state = initState, action) {
  switch (action.type) {
    case dialogActionTypes.openDialog:
      return handleOpenDialog(state, action);

    case dialogActionTypes.closeDialog:
      return handleCloseDialog(state, action);

    default:
      return state;
  }
}
